import { getApiBaseUrl } from './utils/apiConfig';

// Get the API base URL - will automatically use mathventurenp.com in production
const BASE = getApiBaseUrl();

export async function fetchQuiz(klass) {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user.token || localStorage.getItem('token');
  
  const headers = {
    'Content-Type': 'application/json'
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const res = await fetch(`${BASE}/api/quiz?class=${klass}`, { headers });
  const data = await res.json();
  
  // Return just the questions array for compatibility
  return data.questions || [];
}

export async function submitScore(payload) {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const token = user.token || localStorage.getItem('token');
    
    const headers = {
      'Content-Type': 'application/json'
    };
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Transform payload to match backend format
    const backendPayload = {
      game_type: 'quiz',
      class_level: payload.class,
      score: payload.score,
      correct_answers: payload.correct,
      total_questions: payload.total,
      time_taken: payload.time_taken || 0,
      user_id: user.id // Include the actual user ID
    };
    
    const res = await fetch(`${BASE}/api/scores`, {
      method: "POST",
      headers,
      body: JSON.stringify(backendPayload)
    });
    
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    
    return res.json();
  } catch (error) {
    console.error('Error submitting score:', error);
    // Return a default response so the quiz can still complete
    return { success: false, error: error.message };
  }
}

export async function register(username, password) {
  const res = await fetch(`${BASE}/api/register`, {
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body: JSON.stringify({username, password})
  });
  return res.json();
}

export async function login(username, password) {
  const res = await fetch(`${BASE}/api/login`, {
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body: JSON.stringify({username, password})
  });
  return res.json();
}

export async function getLeaderboard(klass) {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user.token || localStorage.getItem('token');
  
  const headers = {
    'Content-Type': 'application/json'
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const res = await fetch(`${BASE}/api/leaderboard?class_level=${klass}`, { headers });
  const data = await res.json();
  // Return just the leaderboard array for compatibility
  return data.leaderboard || [];
}
